import dayjs from 'dayjs';
import { getPostCodeClass } from '../utils';
export var HIGH_DEDUCTIBLE = 300;
export var LOW_DEDUCTIBLE = 150;
var BASE_PRICE = {
    // Yearly
    BASIC: 277.49,
    ADVANCED: 486.95,
};
// Dynamic price that should be added to the base premium before factors applied
var PROPERTY_ADDON_PRICE = {
    BASIC: 59.21,
    ADVANCED: 99.47,
};
// Static price that should be added to the factored ground premium
var CRIMINAL_ADDON_PRICE = {
    BASIC: 39.71,
    ADVANCED: 39.71,
};
var AgeFactor;
(function (AgeFactor) {
    AgeFactor[AgeFactor["18_TO_20"] = 0.84] = "18_TO_20";
    AgeFactor[AgeFactor["21_TO_23"] = 0.88] = "21_TO_23";
    AgeFactor[AgeFactor["24_TO_26"] = 0.92] = "24_TO_26";
    AgeFactor[AgeFactor["27_TO_32"] = 0.96] = "27_TO_32";
    AgeFactor[AgeFactor["33_TO_34"] = 0.98] = "33_TO_34";
    AgeFactor[AgeFactor["35_AND_ABOVE"] = 1] = "35_AND_ABOVE";
    AgeFactor[AgeFactor["UNKNOWN"] = 1] = "UNKNOWN";
})(AgeFactor || (AgeFactor = {}));
var ProfessionFactor = {
    EMPLOYED: 1.0,
    SELF_EMPLOYED: 1.15,
    CIVIL_PUBLIC_SERVANT: 0.85,
    STUDENT: 0.85,
    RETIRED: 0.75,
    LOOKING_FOR_JOB: 1.0,
    UNKNOWN_PROFESSION: 1.0,
    FREELANCER: 1.15,
    JOB_SEARCHING: 1.0,
};
var FamilyFactor = {
    FAMILY: 1.0,
    SINGLE: 0.9,
};
var ZipCodeFactor = {
    '1': 0.85,
    '2': 0.89,
    '3': 0.91,
    '4': 0.93,
    '5': 0.95,
    '6': 0.95,
    '7': 1.08,
    '8': 1.15,
    '9': 1.2,
    '10': 1.35,
    '99': 1.0,
};
export var getAgeFactor = function (dateOfBirth) {
    var age = dayjs().diff(dateOfBirth, 'years');
    if (age < 18) {
        throw new Error("Age can't be under 18");
    }
    if (age >= 18 && age <= 20) {
        return AgeFactor['18_TO_20'];
    }
    if (age >= 21 && age <= 23) {
        return AgeFactor['21_TO_23'];
    }
    if (age >= 24 && age <= 26) {
        return AgeFactor['24_TO_26'];
    }
    if (age >= 27 && age <= 32) {
        return AgeFactor['27_TO_32'];
    }
    if (age >= 33 && age <= 34) {
        return AgeFactor['33_TO_34'];
    }
    if (age >= 35) {
        return AgeFactor['35_AND_ABOVE'];
    }
    return AgeFactor.UNKNOWN;
};
var getMonthlyPrice = function (price) {
    return Math.round((price / 12) * 100) / 100;
};
export var calculateLegalPricing = function (_a) {
    var plan = _a.plan, addons = _a.addons, dateOfBirth = _a.dateOfBirth, profession = _a.profession, postcode = _a.postcode, familyStatus = _a.familyStatus;
    var totalFactoredPrice = 0;
    var basePrice = BASE_PRICE[plan];
    var propertyPrice = PROPERTY_ADDON_PRICE[plan];
    var criminalPrice = CRIMINAL_ADDON_PRICE[plan];
    var ageFactor = getAgeFactor(dateOfBirth);
    var postcodeClass = getPostCodeClass(postcode) || 99;
    var baseFactoredPrice = basePrice *
        ageFactor *
        FamilyFactor[familyStatus] *
        ProfessionFactor[profession] *
        ZipCodeFactor[postcodeClass.toString()];
    var propertyFactoredPrice = propertyPrice *
        ageFactor *
        FamilyFactor[familyStatus] *
        ProfessionFactor[profession] *
        ZipCodeFactor[postcodeClass.toString()];
    totalFactoredPrice += baseFactoredPrice;
    addons.forEach(function (addon) {
        switch (addon) {
            case 'PROPERTY':
                totalFactoredPrice += propertyFactoredPrice;
                break;
            case 'CRIMINAL':
                totalFactoredPrice += criminalPrice;
                break;
            default:
                throw new Error('Unknown addon');
        }
    });
    return {
        totalPremium: getMonthlyPrice(totalFactoredPrice),
        basePremium: getMonthlyPrice(baseFactoredPrice),
        addons: {
            PROPERTY: addons.includes('PROPERTY')
                ? getMonthlyPrice(propertyFactoredPrice)
                : 0,
            CRIMINAL: addons.includes('CRIMINAL')
                ? getMonthlyPrice(criminalPrice)
                : 0,
        },
    };
};
